import React from 'react'
import Timer from './Timer'

function CountDown() {
    return (
        <>
            {/* CountDown area Start */}
            <section className="rts-countdown-area rts-section-gap bg-two">
                <div className="container">
                    <div className="section-inner">
                        <div className="row">
                            <div className="col-lg-6">
                                <div
                                    className="left-side-content wow fadeInLeft"
                                    data-wow-delay=".4s"
                                    data-wow-duration="1s"
                                >
                                    <div className="section-title-area">
                                        <p className="sub-title">Countdown</p>
                                        <h2 className="section-title">The Countdown to Greatness!</h2>
                                    </div>
                                    <p className="desc mb--50">
                                        The journey begins now! Time is running out to secure your spot
                                        in the [Token Name] revolution. Don’t miss this limited-time
                                        opportunity to be part of a groundbreaking project that’s
                                        changing the game. Join us before the timer hits zero!
                                    </p>
                                    <div className="button-area">
                                        <div className="button with-after2">
                                            <a href="#" className="rts-btn btn-primary">
                                                Buy Token
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div
                                    className="right-side-countdown wow fadeInRight"
                                    data-wow-delay=".4s"
                                    data-wow-duration="1s"
                                >
                                    <div className="inner">
                                        <h3 className="title">The Clock Is Ticking</h3>
                                        <Timer />
                                        <div className="button with-after">
                                            <a href="#" className="rts-btn">
                                                Claim Your Tokens
                                            </a>
                                        </div>
                                        <ul className="payment-area mt--25">
                                            <li>
                                                <img src="assets/images/countdown/visa.svg" alt="" />
                                            </li>
                                            <li>
                                                <img src="assets/images/countdown/paypal.svg" alt="" />
                                            </li>
                                            <li>
                                                <img src="assets/images/countdown/skrill.svg" alt="" />
                                            </li>
                                            <li>
                                                <img src="assets/images/countdown/bitcoin.svg" alt="" />
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="shape-area">
                    <img src="assets/images/roadmap/shape-01.svg" alt="" />
                    <img src="assets/images/roadmap/shape-02.svg" alt="" />
                    <img src="assets/images/roadmap/shape-03.svg" alt="" />
                </div>
            </section>
            {/* CountDown area End */}
        </>

    )
}

export default CountDown